// State module for dashboard information
// import makeListRequest from './makeQueryParams';
import dashboardDispatcherService from '@/services/services/dashboardDispatcher.service';
import SimpleDataModule from '@/store/simpleDataModule';

const SelectedRequests = new SimpleDataModule([], { datas: null });

SelectedRequests.actions = {
  setParams({ commit, getters }, params) {
    commit('SET_PARAMS', { ...getters.params, ...params });
  },
  load({ commit }, liste) {
    const maliste = liste.liste;
    const orEntities = liste.entities
      ? '{"$or":[' +
        liste.entities
          .map((el) => `{"entity_nav_full_id":{"$like":"${el.nav_full_id}%"}}`)
          .join(`,`) +
        ']}'
      : '';
    const orProp = liste.property_ordo
      ? `{"$or":[{"property_ordo":{"$eq":"${liste.property_ordo}"}}]}`
      : '';
    const orTech = liste.technician_ordo
      ? `{"$or":[{"technician_ordo":{"$eq":"${liste.technician_ordo}"}}]}`
      : '';
    const orDay = liste.all_day
      ? `{"$or":[{"all_day":{"$eq":"${liste.all_day}"}}]}`
      : '';
    const or = orEntities
      .concat(orProp ? ',' + orProp : '')
      .concat(orTech ? ',' + orTech : '')
      .concat(orDay ? ',' + orDay : '');
    commit('SET_LOADING');
    dashboardDispatcherService
      .getItems(
        {
          params: {
            liste: maliste,
            limit: 400,
            q: {
              $orderby: { signalisation_datetime: 'ASC' },
              $and: JSON.parse('[' + or + ']'),
            },
          },
        },
        {}
      )
      .then((res: any) => {
        commit('SET_DATA', res);
      })
      .catch((err) => {
        commit('SET_ERROR', err);
      });
  },
};

export default SelectedRequests;
